import { Component } from 'react';
import service from '../../core/service';

interface IProps {

}

interface IState {
  str: string;
  loading: boolean;
  categoriesList: Array<any>;
  subcategories: Array<any>;
  categorySelected?: any;

}

export class FaqController extends Component<IProps, IState> {


  state: IState = {
    str: "",
    loading: false,
    categoriesList: [],
    subcategories: [],
    categorySelected: []



  };

  delayDebounceSearch: any;
  search = (e: any) => {
    this.setState({ str: e })
    clearTimeout(this.delayDebounceSearch);
    this.delayDebounceSearch = setTimeout(() => {
      this.getsubCategories()
    }, 1000);
  };
  getCategoriesList = async () => {
    this.setState({ loading: true })
    try {
      const response = await service.Faq.category();
      if (response) {
        this.setState({ categoriesList: response?.data?.data, loading: false, categorySelected: response?.data?.data?.[0] })
        this.getsubCategories(response?.data?.data[0])
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };

  getsubCategories = async (catItem = this.state.categorySelected, search = this.state.str) => {
    this.setState({ subcategories: [] })
    try {
      const response = await service.Faq.subCategory(search, catItem?.id);
      if (response) {
        this.setState({ subcategories: response?.data?.data, categorySelected: catItem })
      } else {
      }
    } catch (error) {
      // throw error;
    }
  };
}
export default FaqController;